import React, { useState } from 'react';
import translate from '../translate';
import { useSelector } from 'react-redux';

function GetQuote() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'getQuote';
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const submitRequest = (e) => {
        setErrorMessage('');
        setSuccessMessage('');
        e.preventDefault();
        const form = document.getElementById('contact-form');
        const formData = new FormData(form);
        let isValid = true;
        formData.entries().forEach(([key, value]) => {
            if(value === '') {
                setErrorMessage(translate(componentName, 'errorFillBlanks', language));
                console.log("error")
                isValid = false;
            }
        });
        if(isValid) {
            fetch('https://api.kodart.az/clientrequest/quoterequest', {
                method: 'POST',
                body: formData,
            })
            .then(response => {
                console.log(response);
                form.reset();
                alert(translate(componentName, 'successMessage', language));
            })
        }else{
            setErrorMessage(translate(componentName, 'errorMessage', language));
        }
        
    }


    return (
        <section className="getquote-section pb-130">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-8">
                    <div className="section-heading section-heading__style-2 text-center mb-60">
                        <span className="sub-heading">{translate(componentName, 'subHeading', language)}</span>
                        <h2 className="heading">{translate(componentName, 'heading', language)}</h2>
                    </div>
                </div>
            </div>
            <div className="row g-0">
                <div className="col-xl-6">
                    <div className="img-wrapper">
                        <img src="assets/img/bg/alpinesoft-office.png" alt=""/>
                    </div>
                </div>
                <div className="col-xl-6">
                    <div className="getquote-form-wrapper">
                        <form  id="contact-form">
                            <div className="input-field mt-30">
                                <label htmlFor="name">{translate(componentName, 'nameLabel', language)}</label>
                                <input type="text" name="fullName" id="name" placeholder={translate(componentName, 'namePlaceholder', language)}/>
                            </div>
                            <div className="input-field mt-30">
                                <label htmlFor="company">{translate(componentName, 'companyLabel', language)}</label>
                                <input type="text" name="company" id="company" placeholder={translate(componentName, 'companyPlaceholder', language)}/>
                            </div>
                            <div className="input-field mt-30">
                                <label htmlFor="email">{translate(componentName, 'emailLabel', language)}</label>
                                <input type="email" name="email" id="email" placeholder={translate(componentName, 'emailPlaceholder', language)}/>
                            </div>
                            <div className="input-field mt-30">
                                <label htmlFor="subject">{translate(componentName, 'subjectLabel', language)}</label>
                                <input type="text" name="subject" id="subject" placeholder={translate(componentName, 'subjectPlaceholder', language)}/>
                            </div>
                            <div className="input-field mt-30">
                                <label htmlFor="message">{translate(componentName, 'messageLabel', language)}</label>
                                <textarea name="message" id="message" placeholder={translate(componentName, 'messagePlaceholder', language)}></textarea>
                            </div>
                            <button onClick={(e)=>submitRequest(e)} type="submit" className="btn btn__round mt-20">{translate(componentName, 'submitButton', language)} <span></span></button>
                            <p className="form-error-message">{errorMessage}</p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
}

export default GetQuote;